import React from 'react';
/* eslint-disable max-len */

const Accessibility = (): JSX.Element => (
  <svg viewBox="0 0 20 20" width="20px" height="20px">
    <path d="M10,20c5.5,0,10-4.5,10-10S15.5,0,10,0,0,4.5,0,10s4.5,10,10,10ZM5.8,16.9l2.2-2.2c1.3.5,2.7.5,4,0l2.2,2.2c-2.5,1.5-5.8,1.5-8.3,0ZM13.2,10c0,1.8-1.4,3.2-3.2,3.2s-3.2-1.4-3.2-3.2,1.4-3.2,3.2-3.2,3.2,1.4,3.2,3.2ZM16.9,14.2l-2.2-2.2c.5-1.3.5-2.7,0-4l2.2-2.2c1.5,2.5,1.5,5.8,0,8.3ZM14.2,3.1l-2.2,2.2c-1.3-.5-2.7-.5-4,0l-2.2-2.2c2.5-1.5,5.8-1.5,8.3,0ZM3.1,5.8l2.2,2.2c-.5,1.3-.5,2.7,0,4l-2.2,2.2c-1.5-2.5-1.5-5.8,0-8.3Z" fillRule="evenodd" clipRule="evenodd"/>
  </svg>
);

export default Accessibility;
